var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"full-sceen-tips",on:{"click":_vm.remove}},[_c('v-mask'),_c('div',{staticClass:"horizontal-center container",attrs:{"ondragstart":"return false;"},domProps:{"innerHTML":_vm._s(_vm.html)}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }